(() => {
  const goals = [
    ['hydrate', 'Hydrateren'], ['nourish', 'Voeden'], ['glow', 'Meer uitstraling'], ['purify', 'Zuiveren en in balans brengen'],
    ['fine', 'Fijne lijntjes verzachten'], ['deep', 'Diepe rimpels minder zichtbaar maken'], ['spots', 'Pigmentvlekken minder zichtbaar maken'], ['calm', 'Roodheid en gevoeligheid kalmeren']
  ];
  const bodyGoals = [['hydrate', 'Een droge huid hydrateren en voeden'], ['firm', 'Huidverslapping en verlies van stevigheid verzorgen'], ['shape', 'Plaatselijke vetophopingen en lichaamscontouren verzorgen'], ['cellulite', 'Een huid met cellulite verzorgen'], ['light', 'Zware en vermoeide benen verfrissen']];
  const q = (title, options, multi = false) => ({ title, options, multi });
  const questions = {
    face: [
      q('Wat wil je vooral voor jouw huid bereiken?', goals),
      q('Heb je nog een tweede huidwens?', [...goals, ['eyes', 'Wallen en donkere kringen minder zichtbaar maken'], ['none', 'Nee, dit is mijn belangrijkste huidwens']]),
      q('Is jouw huid gevoelig?', [['yes', 'Ja, mijn huid reageert snel'], ['no', 'Nee, mijn huid is niet gevoelig']]),
      q('Hoe wil je jouw routine bekijken?', [['simple', 'Een kort overzicht: eerst 4 producten'], ['complete', 'Een ruimer overzicht: eerst 5 producten'], ['advanced', 'De volledige routine met alle producten']])
    ],
    body: [
      q('Wat is jouw belangrijkste wens voor je lichaamshuid?', bodyGoals),
      q('Heb je nog een tweede wens voor je lichaamshuid?', [...bodyGoals, ['none', 'Nee, dit is mijn belangrijkste huidwens']]),
      q('Ben je zwanger?', [['no', 'Nee'], ['yes', 'Ja'], ['private', 'Dat bespreek ik liever met mijn huidexpert']]),
      q('Heb je daarnaast last van pijn of aanhoudende zwelling?', [['no', 'Nee'], ['yes', 'Ja'], ['private', 'Dat bespreek ik liever persoonlijk']])
    ],
    sun: [
      q('Voor welk moment zoek je zonverzorging?', [['before', 'Vóór zonblootstelling: mijn huid voorbereiden'], ['during', 'Tijdens zonblootstelling: mijn huid beschermen'], ['after', 'Na zonblootstelling: mijn huid verzorgen']]),
      q('Verbrandt jouw huid snel in de zon?', [['yes', 'Ja, mijn huid verbrandt snel'], ['no', 'Nee, mijn huid verbrandt niet snel'], ['unknown', 'Dat weet ik niet']]),
      q('Herken je één of meer van deze situaties?', [['pregnant', 'Zwangerschap'], ['spots', 'Pigmentvlekken'], ['intense', 'Zon in de tropen, in de sneeuw of op het water'], ['none', 'Geen van bovenstaande']], true)
    ]
  };
  const areaNames = { face: 'Gezicht', body: 'Lichaam', sun: 'Zonverzorging' };
  const escape = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const faceRoutes = {
  "routine-huidverkleuringen-droge-huid-pigmentvlekken": {
    "path": "/pages/routine-huidverkleuringen-droge-huid-pigmentvlekken",
    "title": "Droge huid met pigmentvlekken"
  },
  "routine-droge-gedehydrateerde-huid": {
    "path": "/pages/routine-droge-gedehydrateerde-huid",
    "title": "Droge en gedehydrateerde huid"
  },
  "routine-fijne-lijntjes-onzuivere-huid": {
    "path": "/pages/routine-fijne-lijntjes-onzuivere-huid",
    "title": "Onzuivere/vette huid met fijne lijntjes"
  },
  "routine-fijne-lijntjes-doffe-huid": {
    "path": "/pages/routine-fijne-lijntjes-doffe-huid",
    "title": "Doffe huid met fijne lijntjes"
  },
  "routine-diepe-rimpels-doffe-huid": {
    "path": "/pages/routine-diepe-rimpels-doffe-huid",
    "title": "Doffe huid met diepe rimpels"
  },
  "routine-huidverkleuringen-onzuiver-huid-pigmentvlekken": {
    "path": "/pages/routine-huidverkleuringen-onzuiver-huid-pigmentvlekken",
    "title": "Onzuivere huid met pigmentvlekken"
  },
  "routine-onzuivere-vette-huid-fijne-lijntjes": {
    "path": "/pages/routine-onzuivere-vette-huid-fijne-lijntjes",
    "title": "Onzuivere/vette huid met fijne lijntjes"
  },
  "routine-diepe-rimpels-diepe-rimpels": {
    "path": "/pages/routine-diepe-rimpels-diepe-rimpels",
    "title": "Diepe rimpels"
  },
  "routine-onzuivere-vette-huid-onzuiverheden": {
    "path": "/pages/routine-onzuivere-vette-huid-onzuiverheden",
    "title": "Onzuivere & vette huid"
  },
  "routine-onzuivere-vette-huid-doffe-huid": {
    "path": "/pages/routine-onzuivere-vette-huid-doffe-huid",
    "title": "Doffe huid met onzuiverheden"
  },
  "routine-gevoelige-huid-fijne-lijntjes": {
    "path": "/pages/routine-gevoelige-huid-fijne-lijntjes",
    "title": "Gevoelige huid met fijne lijntjes"
  },
  "routine-diepe-rimpels-droge-huid": {
    "path": "/pages/routine-diepe-rimpels-droge-huid",
    "title": "Droge huid met diepe rimpels"
  },
  "routine-fijne-lijntjes-fijne-lijntjes": {
    "path": "/pages/routine-fijne-lijntjes-fijne-lijntjes",
    "title": "Fijne lijntjes"
  },
  "routine-huidverkleuringen-gevoelige-huid-pigmentvlekken": {
    "path": "/pages/routine-huidverkleuringen-gevoelige-huid-pigmentvlekken",
    "title": "Gevoelige huid met pigmentvlekken"
  },
  "routine-huidverkleuringen-rimpels-pigmentvlekken": {
    "path": "/pages/routine-huidverkleuringen-rimpels-pigmentvlekken",
    "title": "Huid met rimpels en pigmentvlekken"
  },
  "routine-diepe-rimpels-njzltq-copy-copy-copy-copy-copy-copy-copy-copy-copy-copy": {
    "path": "/pages/routine-diepe-rimpels-njzltq-copy-copy-copy-copy-copy-copy-copy-copy-copy-copy",
    "title": "Couperose gevoelige huid"
  },
  "routine-onzuivere-huid-gevoelige-huid-vette-huid": {
    "path": "/pages/routine-onzuivere-huid-gevoelige-huid-vette-huid",
    "title": "Gevoelige huid met onzuiverheden"
  },
  "routine-droge-huid-lipidentekort": {
    "path": "/pages/routine-droge-huid-lipidentekort",
    "title": "Droge huid met lipidentekort"
  },
  "routine-gevoelige-droge-huid": {
    "path": "/pages/routine-gevoelige-droge-huid",
    "title": "Gevoelige en droge huid met couperose"
  },
  "routine-droge-huid-gevoelige-huid": {
    "path": "/pages/routine-droge-huid-gevoelige-huid",
    "title": "Gevoelige en droge huid"
  },
  "routine-gevoelige-huid-diepe-rimpels": {
    "path": "/pages/routine-gevoelige-huid-diepe-rimpels",
    "title": "Gevoelige huid met diepe rimpels"
  },
  "routine-fijne-lijntjes-gevoelige-huid": {
    "path": "/pages/routine-fijne-lijntjes-gevoelige-huid",
    "title": "Gevoelige huid met fijne lijntjes"
  },
  "routine-droge-doffe-huid": {
    "path": "/pages/routine-droge-doffe-huid",
    "title": "Droge en doffe huid"
  },
  "routine-diepe-rimpels-gevoelige-huid": {
    "path": "/pages/routine-diepe-rimpels-gevoelige-huid",
    "title": "Gevoelige huid met diepe rimpels"
  }
};
  const faceRouteOrder = {
  "deep": {
    "calm": "routine-diepe-rimpels-gevoelige-huid",
    "dry": "routine-diepe-rimpels-droge-huid",
    "glow": "routine-diepe-rimpels-doffe-huid",
    "default": "routine-diepe-rimpels-diepe-rimpels"
  },
  "calm": {
    "deep": "routine-gevoelige-huid-diepe-rimpels",
    "fine": "routine-gevoelige-huid-fijne-lijntjes",
    "dry": "routine-gevoelige-droge-huid",
    "default": "routine-diepe-rimpels-njzltq-copy-copy-copy-copy-copy-copy-copy-copy-copy-copy"
  },
  "fine": {
    "calm": "routine-fijne-lijntjes-gevoelige-huid",
    "purify": "routine-fijne-lijntjes-onzuivere-huid",
    "glow": "routine-fijne-lijntjes-doffe-huid",
    "default": "routine-fijne-lijntjes-fijne-lijntjes"
  },
  "dry": {
    "calm": "routine-droge-huid-gevoelige-huid",
    "glow": "routine-droge-doffe-huid",
    "default": "routine-droge-gedehydrateerde-huid",
    "nourish": "routine-droge-huid-lipidentekort"
  },
  "purify": {
    "calm": "routine-onzuivere-huid-gevoelige-huid-vette-huid",
    "fine": "routine-onzuivere-vette-huid-fijne-lijntjes",
    "glow": "routine-onzuivere-vette-huid-doffe-huid",
    "default": "routine-onzuivere-vette-huid-onzuiverheden"
  },
  "spots": {
    "deep": "routine-huidverkleuringen-rimpels-pigmentvlekken",
    "fine": "routine-huidverkleuringen-rimpels-pigmentvlekken",
    "dry": "routine-huidverkleuringen-droge-huid-pigmentvlekken",
    "purify": "routine-huidverkleuringen-onzuiver-huid-pigmentvlekken",
    "calm": "routine-huidverkleuringen-gevoelige-huid-pigmentvlekken"
  }
};
  function matchFaceRoutine(a) {
    const normalize = value => ['hydrate', 'nourish'].includes(value) ? 'dry' : value;
    const primary = normalize(a[0]), secondary = normalize(a[1]);
    const sensitive = a[2] === 'yes' || primary === 'calm' || secondary === 'calm';
    const options = faceRouteOrder[primary] || {};
    const refinement = sensitive && primary !== 'calm' ? 'calm' : secondary;
    const exact = options[refinement];
    const fallback = sensitive && primary !== 'calm' ? undefined : (primary === 'dry' && a[0] === 'nourish' ? options.nourish : options.default);
    const route = faceRoutes[exact || fallback];
    const covered = [primary, ...(exact ? [refinement] : [])];
    const wishes = [...new Set([primary, secondary, ...(sensitive ? ['calm'] : [])])].filter(goal => !['none', 'eyes'].includes(goal));
    return { route, unmatched: wishes.filter(goal => !covered.includes(goal)) };
  }
  async function readRoutine(path, signal) {
    const response = await fetch(path, { signal, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Routine niet beschikbaar');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const main = doc.querySelector('main');
    if (!main) throw new Error('Routine niet beschikbaar');
    const products = [];
    let label = 'Uit deze routine';
    main.querySelectorAll('h2, [data-instant-form-product-url], a[href*="/products/"]').forEach(el => {
      if (el.tagName === 'H2') {
        const text = el.textContent.replace(/\s+/g, ' ').trim();
        if (/^STAP\s*\d/i.test(text)) label = text;
        else if (/MAAK.*ROUTINE COMPLEET/i.test(text)) label = 'Aanvullende verzorging';
        return;
      }
      const raw = el.getAttribute('data-instant-form-product-url') || el.getAttribute('href');
      if (!raw) return;
      const url = new URL(raw, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return;
      const handle = url.pathname.slice('/products/'.length).replace(/\/$/, '');
      if (handle && !products.some(p => p.handle === handle)) products.push({ handle, label });
    });
    if (!products.length) throw new Error('Geen routineproducten gevonden');
    return { title: main.querySelector('h1')?.textContent.trim(), products };
  }
  const bodyRoutes = {
  "hydrate": {
    "path": "/pages/routine-lichaam-gedehydrateerde-droge-huid",
    "title": "Gedehydrateerde & Droge huid"
  },
  "firm": {
    "path": "/pages/routine-lichaam-huidveroudering-huidverslapping",
    "title": "Huidveroudering & huidverslapping"
  },
  "shape": {
    "path": "/pages/routine-lichaam-plaatselijke-vetophopingen",
    "title": "Plaatselijke vetophopingen"
  },
  "cellulite": {
    "path": "/pages/routine-lichaam-cellulite",
    "title": "Cellulite"
  },
  "light": {
    "path": "/pages/routine-lichaam-zware-benen",
    "title": "Zware benen"
  },
  "pregnant": {
    "path": "/pages/routine-lichaam-zwangerschap",
    "title": "Zwangerschap"
  }
};
  const sunRoutes = {
  "before": {
    "path": "/pages/routine-presun",
    "title": "Pre Sun"
  },
  "during": {
    "path": "/pages/routine-zonbescherming",
    "title": "Tijdens zonblootstelling"
  },
  "after": {
    "path": "/pages/routine-after-sun",
    "title": "After Sun"
  }
};
  function recommend(area, a) {
    let title, intro, notice = '', routine, products = [];
    if (area === 'face') {
      const { route, unmatched } = matchFaceRoutine(a);
      title = route?.title || 'Stem jouw routine persoonlijk af';
      routine = route?.path || (a[0] === 'spots' ? '/pages/routines-gezicht-huidverkleuringen-pigmentvlekken' : '/pages/routines-gezicht');
      intro = route ? 'Deze bestaande Bioline Jatò-routine sluit aan bij de huidbehoeften die je hebt aangegeven. Hieronder vind je de producten die op deze routinepagina staan, in dezelfde volgorde.' : 'Voor jouw antwoorden is geen specifieke combinatie gevonden in onze bestaande routines. Bekijk de routines en laat jouw huidexpert een passende keuze met je maken.';
      if (route && unmatched.length) {
        const names = { dry: 'hydratatie en voeding', glow: 'meer uitstraling', purify: 'onzuiverheden', fine: 'fijne lijntjes', deep: 'diepe rimpels', spots: 'pigmentvlekken' };
        notice = 'Deze routine dekt niet al je huidwensen. Bespreek ook ' + unmatched.map(goal => names[goal] || goal).join(' en ') + ' met jouw huidexpert; daarvoor zijn geen losse producten aan deze routine toegevoegd.';
      }
      if (a[1] === 'eyes') notice += (notice ? ' ' : '') + 'Je wilt ook aandacht voor wallen of donkere kringen. Laat jouw huidexpert beoordelen welke oogverzorging daarbij past.';
      return { title, intro, notice, routine, products, sourceRoutine: !!route, limit: a[3] === 'simple' ? 4 : a[3] === 'complete' ? 5 : Infinity };
    } else if (area === 'body') {
      const r = bodyRoutes[a[2] === 'yes' ? 'pregnant' : a[0]];
      title = r.title; routine = r.path;
      intro = a[2] === 'yes' ? 'Je gaf aan dat je zwanger bent. Daarom tonen we de bestaande Bioline Jatò-routine voor lichaamsverzorging tijdens de zwangerschap, met de producten van die pagina.' : 'Jouw eerste huidwens bepaalt de lichaamsroutine. Hieronder staan de producten van die bestaande Bioline Jatò-routine, in dezelfde volgorde als op de routinepagina.';
      if (a[2] === 'private' || a[3] !== 'no') {
        title = 'Stem jouw lichaamsroutine persoonlijk af';
        intro = 'Je wilt jouw situatie persoonlijk bespreken, of je noemt pijn of aanhoudende zwelling. Daarom maakt de quiz nu geen automatische productselectie.';
        notice = a[3] === 'yes' ? 'Bespreek pijn of aanhoudende zwelling met een arts. Jouw huidexpert kan je helpen de lichaamsverzorging daarna af te stemmen.' : 'Jouw huidexpert helpt je een routine te kiezen die past bij jouw situatie.';
        return { title, intro, notice, routine: '/pages/routines-lichaam', products, sourceRoutine: false };
      }
      if (a[2] === 'yes') notice = 'De zwangerschapsroutine krijgt voorrang op je andere huidwensen. Stem het gebruik persoonlijk af met jouw huidexpert.';
      else if (a[1] !== 'none' && a[1] !== a[0]) notice = 'Je tweede huidwens is: ' + (bodyGoals.find(([key]) => key === a[1])?.[1] || '') + '. Hiervoor bestaat geen afzonderlijke combinatieroutine op onze website. Bespreek deze aanvulling met jouw huidexpert; de producten van beide routines zijn niet samengevoegd.';
      return { title, intro, notice, routine, products, sourceRoutine: true };
    } else {
      const r = sunRoutes[a[0]];
      title = r.title; routine = r.path;
      intro = 'Je koos verzorging ' + { before: 'vóór', during: 'tijdens', after: 'na' }[a[0]] + ' zonblootstelling. Hieronder vind je de producten uit de bijbehorende bestaande Bioline Jatò-routine.';
      const special = a[2] || [];
      notice = a[0] === 'during' ? 'Deze routinepagina bevat verschillende opties voor zonbescherming. Laat jouw huidexpert de passende variant en het gebruik met je afstemmen.' : 'Voorbereidende verzorging en aftersun vervangen geen zonbescherming. Bekijk ook de routine voor tijdens zonblootstelling.';
      if (a[1] === 'yes') notice += ' Je gaf aan dat je snel verbrandt. Bespreek dit bij de keuze van jouw zonbescherming.';
      else if (a[1] === 'unknown') notice += ' Je weet nog niet hoe snel je huid verbrandt. Laat jouw huidexpert hierover met je meedenken.';
      if (special.includes('spots')) notice += ' Neem ook je pigmentvlekken mee in het advies van jouw huidexpert.';
      if (special.includes('intense')) notice += ' Vertel je huidexpert dat je zonblootstelling in de tropen, sneeuw of op het water verwacht.';
      if (special.includes('pregnant')) notice += ' Je gaf zwangerschap aan. Laat de productkeuze persoonlijk controleren voordat je deze gaat gebruiken.';
      return { title, intro, notice, routine, products, sourceRoutine: true, relatedRoutine: a[0] !== 'during' ? sunRoutes.during : null };
    }
  }
  function mount(root) {
    if(root.dataset.quizReady)return;root.dataset.quizReady='true';
    const app=root.querySelector('[data-quiz-app]');
    let catalog;try{catalog=JSON.parse(root.querySelector('[data-quiz-products]').textContent)}catch{catalog=[]}
    const byHandle=new Map(catalog.map(p=>[p.handle,p]));
    let area=null,index=0,answers=[],resultRequest=null;
    function focus() { const el=app.querySelector('[data-focus]'); if(el){el.focus({preventScroll:true});app.scrollIntoView({behavior:'auto',block:'start'});} }
    function start() {
      resultRequest?.abort();area=null;index=0;answers=[];
      app.innerHTML='<h2 data-focus tabindex="-1">Waar wil jij aandacht aan geven?</h2><p class="blq-subtitle">Kies jouw routine.</p><div class="blq-areas">'+[
        ['face','Gezicht','Hydratatie, een stralende teint, fijne lijntjes of een huid die extra comfort zoekt.','4 vragen','◯'],
        ['body','Lichaam','Voeding, soepelheid, stevigheid of een dagelijks moment van aandacht voor je lichaam.',questions.body.length+' vragen','◌'],
        ['sun','Zonverzorging','Ontdek verzorging voor je gezicht en lichaam, tijdens en na blootstelling aan de zon.',questions.sun.length+' vragen','☼']
      ].map(([id,name,desc,count,icon])=>'<button type="button" class="blq-area" data-area="'+id+'"><span class="blq-icon" aria-hidden="true">'+icon+'</span><b>'+name+'</b><span>'+desc+'</span><span class="blq-start">'+count+' · Start de quiz →</span></button>').join('')+'</div>';
      app.querySelectorAll('[data-area]').forEach(b=>b.addEventListener('click',()=>{area=b.dataset.area;index=0;answers=[];renderQuestion();focus();}));
    }
    function renderQuestion() {
      const list=questions[area],item=list[index];
      const options=item.options.filter(([value])=>!((area==='face'||area==='body')&&index===1&&value===answers[0]));
      const selected=answers[index]??(item.multi?[]:'');
      app.innerHTML='<div class="blq-step-header"><span>'+areaNames[area]+'</span><span>VRAAG '+(index+1)+' VAN '+list.length+'</span></div><div class="blq-progress" role="progressbar" aria-label="Voortgang" aria-valuemin="0" aria-valuemax="'+list.length+'" aria-valuenow="'+(index+1)+'"><span style="width:'+((index+1)/list.length*100)+'%"></span></div><form><fieldset class="blq-form"><legend data-focus tabindex="-1">'+escape(item.title)+'</legend>'+(item.multi?'<p class="blq-subtitle">Meerdere antwoorden mogelijk.</p>':'')+'<div class="blq-options">'+options.map(([value,label])=>'<label class="blq-choice"><input type="'+(item.multi?'checkbox':'radio')+'" name="answer" value="'+escape(value)+'" '+((item.multi?selected.includes(value):value===selected)?'checked':'')+'><span>'+escape(label)+'</span></label>').join('')+'</div></fieldset><div class="blq-actions"><button class="blq-back" type="button" data-back>← Vorige</button><button class="blq-button" type="submit" data-next '+((item.multi?selected.length:!!selected)?'':'disabled')+'>'+(index===list.length-1?'Ontdek jouw routine':'Volgende')+' →</button></div></form>';
      app.querySelectorAll('input').forEach(input=>input.addEventListener('change',()=>{
        if(item.multi){
          if(input.value==='none'&&input.checked)app.querySelectorAll('input').forEach(x=>{if(x!==input)x.checked=false;});
          if(input.value!=='none'&&input.checked)app.querySelector('input[value="none"]').checked=false;
          answers[index]=Array.from(app.querySelectorAll('input:checked')).map(x=>x.value);
        }else answers[index]=input.value;
        app.querySelector('[data-next]').disabled=item.multi?!answers[index].length:!answers[index];
      }));
      app.querySelector('[data-back]').addEventListener('click',()=>{if(index===0)start();else{index--;renderQuestion()}focus()});
      app.querySelector('form').addEventListener('submit',event=>{event.preventDefault();if(!answers[index]||(item.multi&&!answers[index].length))return;
        if((area==='face'||area==='body')&&index===0&&answers[1]===answers[0])answers[1]=undefined;
        if(index<list.length-1){index++;renderQuestion()}else renderResult();focus();
      });
    }
    async function renderResult() {
      resultRequest?.abort();
      const request = new AbortController();
      resultRequest = request;
      const r=recommend(area,answers);
      if (r.sourceRoutine) {
        app.innerHTML = '<h2 data-focus tabindex="-1">Jouw routine wordt opgehaald</h2><p role="status">We laden de producten van de bijbehorende routinepagina.</p><button type="button" class="blq-back" data-cancel>← Antwoorden aanpassen</button>';
        app.querySelector('[data-cancel]').addEventListener('click', () => { request.abort(); index=0; renderQuestion(); focus(); });
        try {
          const source = await readRoutine(r.routine, request.signal);
          if (request.signal.aborted) return;
          r.products = source.products;
          r.title = source.title || r.title;
          if (r.products.some(p => !byHandle.has(p.handle))) r.notice += (r.notice ? ' ' : '') + 'Niet alle producten konden in dit overzicht worden geladen. Bekijk de volledige routine voor alle producten.';
        } catch (error) {
          if (request.signal.aborted) return;
          r.notice += (r.notice ? ' ' : '') + 'De producten konden niet worden geladen. Je kunt de bijbehorende routine hieronder rechtstreeks openen.';
        }
      }
      const cards=r.products.filter((p,i,all)=>byHandle.has(p.handle)&&all.findIndex(x=>x.handle===p.handle)===i);
      const labels=answers.flatMap((value,i)=>questions[area][i].options.filter(([v])=>Array.isArray(value)?value.includes(v):v===value).map(([,label])=>label));
      app.innerHTML='<p class="blq-eyebrow">'+(r.sourceRoutine?'JOUW ROUTINE':'JOUW VERZORGINGSRICHTING')+'</p><h2 data-focus tabindex="-1">'+escape(r.title)+'</h2><p class="blq-result-intro">'+escape(r.intro)+'</p>'+(r.sourceRoutine?'<p class="blq-priority">'+(area==='sun'?'Jouw gekozen moment: ':'Jouw eerste huidwens: ')+escape(questions[area][0].options.find(([key])=>key===answers[0])?.[1]||'')+'</p><p class="blq-source blq-links"><a href="'+escape(r.routine)+'">Bekijk de volledige routine: '+escape(r.title)+' →</a></p><p class="blq-subtitle">De routine bevat verzorgingsstappen en aanvullende opties. Jouw huidexpert helpt je kiezen welke producten je samen gebruikt.</p>':'')+'<details><summary>Jouw antwoorden bekijken</summary><div class="blq-tags">'+labels.map(label=>'<span>'+escape(label)+'</span>').join('')+'</div></details>'+(r.notice?'<p class="blq-notice">'+escape(r.notice)+'</p>':'')+(cards.length?'<div class="blq-products">'+cards.map((c,i)=>{const p=byHandle.get(c.handle);return '<article class="blq-advice-card"'+(i>=(r.limit||Infinity)?' hidden data-extra-product':'')+'><p class="blq-routine-step">'+escape(c.label)+'</p><a class="blq-card-media" href="'+escape(p.url)+'" tabindex="-1" aria-hidden="true"><img src="'+escape(p.image)+'" alt="" width="560" height="560" loading="lazy"></a><div class="blq-card-body"><p class="blq-card-type">'+escape(p.type||'')+'</p><h3><a href="'+escape(p.url)+'">'+escape(p.title)+'</a></h3><p class="blq-card-description">'+escape(p.description||'')+'</p>'+(p.action?'<div class="blq-card-detail"><h4>Werking</h4><p>'+escape(p.action)+'</p></div>':'')+(p.ingredients?'<div class="blq-card-detail"><h4>Actieve ingrediënten</h4><p>'+escape(p.ingredients)+'</p></div>':'')+'</div></article>'}).join('')+'</div>'+(cards.length>r.limit?'<p data-product-count>Je ziet de eerste '+r.limit+' van '+cards.length+' producten uit deze routine.</p><button type="button" class="blq-button" data-show-all>Toon alle producten uit deze routine →</button>':''):'')+'<div class="blq-expert"><div><h3>Maak jouw routine persoonlijk.</h3><p>Jouw Bioline Jatò huidexpert kijkt naar je huid en helpt je de productkeuze, volgorde en frequentie af te stemmen. Het aangekondigde AI-advies is nog niet beschikbaar.</p></div><a class="blq-button" href="/pages/vind-een-spa">Vind jouw huidexpert →</a></div><div class="blq-links"><a href="'+r.routine+'">Lees meer over deze routine →</a>'+(r.relatedRoutine?'<a href="'+escape(r.relatedRoutine.path)+'">Bekijk de routine voor zonbescherming →</a>':'')+'<a href="/collections/thuisverzorging">Bekijk alle producten →</a></div><div class="blq-actions"><button type="button" class="blq-back" data-edit>← Antwoorden aanpassen</button><button type="button" class="blq-back" data-restart>Opnieuw beginnen</button></div>';
      app.querySelector('[data-show-all]')?.addEventListener('click',event=>{ app.querySelectorAll('[data-extra-product]').forEach(card=>{card.hidden=false});app.querySelector('[data-product-count]')?.remove();event.currentTarget.remove(); });
      focus();
      app.querySelector('[data-edit]').addEventListener('click',()=>{index=0;renderQuestion();focus()});
      app.querySelector('[data-restart]').addEventListener('click',()=>{start();focus()});
    }
    start();
  }
  document.querySelectorAll('[data-bioline-quiz]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-bioline-quiz]').forEach(mount));
})();
